var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"fit":_vm.option.attribute.fit,"src":_vm.option.attribute.url?_vm.image(_vm.option.attribute.url):require('@/assets/logo.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }